import { Action } from 'redux'
import { isType } from 'ts-action'
import { IActivityLogReducer, IActivityLog } from 'models/ActivityLog'
import { updateArray, deleteFromArray } from 'helpers/helperFuncs'
import { IPunchCard } from '../../../../models/PunchCard/index'
import {
  GetPunchCardsActivityLogs,
  PunchCardsActivityLogsFetching,
  UpdatePunchCardsActivityLog,
  DeletePunchCardsActivityLog,
} from './actions'

const initialState: IActivityLogReducer<IPunchCard> = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const activityLogsReducer = (
  state = initialState,
  action: Action,
): IActivityLogReducer<IPunchCard> => {
  if (isType(action, GetPunchCardsActivityLogs)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdatePunchCardsActivityLog)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IActivityLog<IPunchCard>>(
      data,
      payload.data,
    )
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeletePunchCardsActivityLog)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IActivityLog<IPunchCard>>(
      data,
      payload,
    )
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, PunchCardsActivityLogsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
